import * as React from "react";
import { cn } from "@/utils/tailwind";

export const CircularProgress = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div className={cn("relative size-20", className)} ref={ref} {...props} />
  );
});

export const CircularProgressContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      className={cn(
        "absolute top-1/2 inset-s-1/2 transform -translate-y-1/2 -translate-x-1/2",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});

export const CircularProgressCircles = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGAttributes<SVGSVGElement>, "viewBox" | "xmlns">
>(({ className, ...props }, ref) => {
  return (
    <svg
      className={cn("size-full -rotate-90", className)}
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    />
  );
});

export const CircularProgressOutline = React.forwardRef<
  SVGCircleElement,
  Omit<React.SVGAttributes<SVGCircleElement>, "cx" | "cy" | "r">
>(({ className, strokeWidth, fill, ...props }, ref) => {
  return (
    <circle
      cx="18"
      cy="18"
      r="16"
      fill={fill || "none"}
      strokeWidth={strokeWidth || "1.25"}
      className={cn("stroke-current text-grey-100", className)}
      ref={ref}
      {...props}
    />
  );
});

export const CircularProgressIndicator = React.forwardRef<
  SVGCircleElement,
  Omit<
    React.SVGAttributes<SVGCircleElement>,
    "cx" | "cy" | "r" | "strokeDashoffset" | "strokeDasharray"
  > & {
    progress?: number;
    color?: string;
  }
>(({ progress = 0, className, strokeWidth, fill, style, ...props }, ref) => {
  return (
    <circle
      cx="18"
      cy="18"
      r="16"
      fill={fill || "none"}
      style={{
        filter: `drop-shadow(color-mix(in srgb, currentColor 20%, transparent) 0 0 1px)`,
        ...style,
      }}
      className={cn("stroke-current text-success-500", className)}
      strokeWidth={strokeWidth || "1.25"}
      strokeDasharray="100"
      strokeDashoffset={(100 - progress).toFixed(2)}
      ref={ref}
      {...props}
    />
  );
});
